export default __webpack_public_path__ + "static/media/woven_fabrics.d541b412.png";